import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';

import theme from './ModalUploadExtensionFailed.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  fileType: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const titleMessage = { id: 'media.create.invalidFileDialog.Title', defaultMessage: '** File type not supported' };
const bodyMessage = { id: 'media.create.InvalidFileDialog.body', defaultMessage: '**  Files of type { fileType } can not be uploaded. Please select a different file' };
const cancelButtonMessage = { id: 'General.Close', defaultMessage: '** Close' };

const ModalUploadExtensionFailed = ({
  intl,
  fileType,
  onCancel,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div>
        <FormattedMessage { ...titleMessage } />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <FormattedMessage
        { ...bodyMessage }
        values={{ fileType }}
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-upload-extension-failed-button"
        label={ intl.formatMessage(cancelButtonMessage) }
        className={ theme.cancelButton }
        background="primary"
        onClick={ onCancel }
      />
    </div>
  </div>
);

ModalUploadExtensionFailed.propTypes = propTypes;

export default ModalUploadExtensionFailed;
